// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__d-Lzh","author":"Table_author__1m-K3","authorImage":"Table_authorImage__1_R0F","unreadRow":"Table_unreadRow__3KioG"};